import React, {useEffect, useState, useRef, useMemo, useCallback} from 'react';
import {useTabHashPersistence} from "../../../../hooks/useTabHashPersistence";
import {useWeekStartsSunday} from "../../../../hooks/useWeekStartsSunday";
import {CustomCard} from "../../../../components/UI/AntCustom/CustomCard";
import {PageWrapper} from "../../../../components/UI/PageWrapper/PageWrapper";
import {useAppDispatch, useAppSelector} from "../../../../store/store";
import {
  clearScheduleResult,
  getSchedule,
} from "../../../../store/reducers/scheduleReducer/scheduleReducer";
import {BookingApiPlaneListRequest, PageModel} from "../../../../proto/generated/api_entities_pb";
import {PlaneStatus} from "../../../../utils/constans/statuses/planeStatuses";
import {InitialPage} from "../../../../utils/constans/pagination/pagination";
import {useSearchParams} from "react-router-dom";
import {IPlaneEvent} from "../../../../store/reducers/scheduleReducer/scheduleReducerTypes";
import {IPlaneShort} from "../../../../store/reducers/fleetReducer/fleetReducerTypes";
import isNumeric from "antd/es/_util/isNumeric";
import styled from "styled-components";
import {Switch} from 'antd';
import {defineMessages, useIntl} from "react-intl";
import {FullCalendarWrapper} from "./components/FullCalendarWrapper";
import {API} from "../../../../API/API";
import {CustomTabs} from "../../../../components/UI/AntCustom/CustomTabs";
import CalendarIcon from "../../../../media/icons/calendar.svg?react";
import CalendarBlackIcon from "../../../../media/icons/calendar_black.svg?react";
import TimelineIcon from "../../../../media/icons/timeline.svg?react";
import TimelineBlackIcon from "../../../../media/icons/timeline_black.svg?react";
import MapIcon from "../../../../media/icons/map.svg?react";
import MapBlackIcon from "../../../../media/icons/map_black.svg?react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import {DebounceSelect, DebounceSelectOptionProps} from "../../../../components/UI/AntCustom/DebounceSelect";
import {ScheduleApiAircraftMapRequest} from "../../../../proto/generated/api_entities_pb";
import {ScheduleApi} from "../../../../API/ApiClasses/ScheduleApi";
import {Modal} from 'antd';
import {fetchOwnPlanes, getInitialOwnPlaneForSelect} from "../../../../utils/helpers/selectDataFetchers/fetchOwnPlanes";
import {CommonFormMessages} from "../../../../intl/commonMessages/CommonFormMessages";
import {EventCalendarSimpleFilters} from "../EventCalendar/components/EventCalendarSimpleFilters";
import {useIsMobile} from "../../../../hooks/useWindowSize";

const ControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SettingsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const TabsAndFiltersRow = styled.div`
  margin-bottom: 8px;
  
  .ant-tabs-nav {
    margin-bottom: 8px;
  }
  
  .ant-tabs-nav-wrap {
    height: fit-content !important;
    align-self: flex-end !important;
  }
  
  .ant-tabs-nav-list {
    align-items: flex-start !important;
  }
  
  .ant-tabs-extra-content {
    margin-bottom: 5px;
    align-self: flex-start !important;
  }
  
  .ant-tabs-tab {
    padding: 8px 12px;
    margin: 0 0 0 8px;
    align-self: flex-start !important;
  }
  
  .ant-tabs-tab-btn {
    padding: 0;
  }

  @media (max-width: 768px) {
    display: flex !important;
    flex-direction: column !important;
    gap: 16px !important;
  }
`;

const FiltersRightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const DesktopFiltersWrapper = styled(FiltersRightWrapper)`
  @media (max-width: 768px) {
    display: none !important;
  }
`;

const MobileFiltersWrapper = styled.div`
  @media (min-width: 769px) {
    display: none !important;
  }
  
  @media (max-width: 768px) {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    width: 100% !important;
    order: 1;
    margin-bottom: 16px;
    gap: 16px;
  }
`;

const TabsWrapper = styled.div`
  @media (max-width: 768px) {
    order: 2;
    width: 100%;
  }
`;

const StyledDebounceSelect = styled(DebounceSelect)`
  .ant-select-selector {
    padding: 5px !important;
    min-height: 32px !important;
    height: auto !important;
    max-height: 120px !important;
    border-radius: 5px !important;
    overflow: hidden !important;
  }

  .ant-select-selection-overflow {
    max-height: 110px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    align-items: flex-start !important;
    flex-wrap: wrap !important;
    gap: 4px !important;
  }

  .ant-select-selection-overflow-item {
    max-height: 22px !important;
    max-width: 100% !important;
    flex-shrink: 1 !important;
    min-width: 0 !important;
  }

  .ant-select-selection-item {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  .ant-select-clear {
    display: none !important;
  }
`;

const WeekToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666666;
`;

const TabContentPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 420px;
  color: #6c6c6c;
  font-size: 16px;
`;

const TabLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const TabIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const MapWrapper = styled.div`
  width: 100%;
  max-width: 1115px;
  aspect-ratio: 1115 / 724;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f0f2f5;

  @media (min-width: 1440px) {
    max-width: none;
    height: 60vh;
    aspect-ratio: auto;
  }
`;

const PlaneTooltipCardModal = styled(Modal)`
  & .ant-modal-content {
    border-radius: 8px;
    width: 328px;
    min-height: 141px;
    background-color: #ffffff;
  }

  & .ant-modal-body {
    padding: 16px;
  }
`

const PlaneTooltipCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const RouteGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto auto;
  position: relative;
  margin-top: 16px;
`;

const RouteSpacer = styled.div`
  grid-column: 2;
  grid-row: 1 / 4;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  min-width: 20px;
`;

const RouteLine = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

const PlaneIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  transform: rotate(90deg);
`;

const RouteLineElement = styled.div`
  flex: 1;
  height: 2px;
  background-color: #808080;
  margin-right: -9px;
`;

const RouteCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #808080;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
`;

const TailNumberText = styled.div`
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.14px;
  align-self: stretch;
`;

const PlaneModelText = styled.div`
  color: #808080;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.11px;
  align-self: stretch;
  margin-top: 4px;
`;

const DateText = styled.div`
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.12px;
  opacity: 0.5;
`;

const AirportCodeText = styled.div`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.16px;
  padding-top: 8px;
`;

const AirportLocationText = styled.div`
  color: #000;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.11px;
  padding-top: 4px;
`;

const PlaneRegistrationNumber = styled.div<{ isMobile?: boolean }>`
  height: 102px;
  display: flex;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  color: #343A40;
  border-radius: 4px;
  background: transparent;
  white-space: normal;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;

  ${props => props.isMobile ? 'padding: 0;' : ''}
`;

const PlaneRegistrationPlaceholder = styled.div<{ isMobile?: boolean }>`
  height: 102px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  color: #bfbfbf;
  border-radius: 4px;

  ${props => props.isMobile ? 'padding: 0;' : ''}
`;

const PlaneRegistrationContainer = styled.div<{ isMobile?: boolean }>`
  width: 140px;
  padding-top: 117px;
  display: flex;
  flex-direction: column;

  @media (min-width: 744px) and (max-width: 768px) {
    padding-top: 140px;
  }

  @media (min-width: 724px) and (max-width: 743px) {
    padding-top: 110px;
  }

  @media (min-width: 535px) and (max-width: 723px) {
    padding-top: 140px;
  }

  @media (max-width: 534px) {
    padding-top: 170px;
  }
`;

const TimelineContentWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  gap: 16px;
`;

const TimelineCalendarContainer = styled.div<{ isMobile?: boolean }>`
  flex: 1;
  ${props => props.isMobile ? `
    min-height: 100%;
  ` : ''}
`;

const TABS = {
  calendar: "calendar",
  timeline: "timeline",
  map: "map",
} as const;

type TabKey = typeof TABS[keyof typeof TABS];


const SchedulePageMessages = defineMessages({
  title: {
    id: "schedulePagePublic.title",
    defaultMessage: "Public Schedule",
  },
  calendarTab: {
    id: "schedulePage.tabs.calendar",
    defaultMessage: "Calendar",
  },
  timelineTab: {
    id: "schedulePage.tabs.timeline",
    defaultMessage: "Timeline",
  },
  mapTab: {
    id: "schedulePage.tabs.map",
    defaultMessage: "Map",
  },
  mapPlaceholder: {
    id: "schedulePage.mapPlaceholder",
    defaultMessage: "Map view will be available soon",
  },
  weekStartsSunday: {
    id: "schedulePage.weekStartsSunday",
    defaultMessage: "Week starts on Sunday",
  },
})

export const SchedulePagePublic = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const isMobile = useIsMobile();
  const {items, isLoading, totalCount} = useAppSelector(state => state.schedule.itemsObject);

  const [searchParams] = useSearchParams();
  const planeIdFromParams = searchParams.get('planeId');
  const planeRegNumberFromParams = searchParams.get('planeRegNumber');
  const defaultSelectedPlane: IPlaneShort | undefined = isNumeric(planeIdFromParams) && planeRegNumberFromParams ? {
    id: Number(planeIdFromParams),
    registrationNumber: planeRegNumberFromParams,
  } : undefined;

  const [selectedPlaneIds, setSelectedPlaneIds] = useState<number[]>(defaultSelectedPlane ? [defaultSelectedPlane.id] : []);
  const [allPlanes, setAllPlanes] = useState<IPlaneShort[]>(defaultSelectedPlane ? [defaultSelectedPlane] : []);

  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const [weekStartsSunday, setWeekStartsSunday] = useWeekStartsSunday();
  const [activeTabKey, setActiveTabKey] = useTabHashPersistence(TABS, TABS.calendar);
  const [visibleDateRange, setVisibleDateRange] = useState<{start: Date, end: Date} | null>(null);
  const [filters, setFilters] = useState<{
    airportIds?: number[];
  }>({});
  const [flightsForMap, setFlightsForMap] = useState<{
    planeId: number;
    registrationNumber: string;
    lat: number;
    lon: number;
    heading: number;
  }[]>([]);
  const [selectedFlightForMap, setSelectedFlightForMap] = useState<{
    planeId: number;
    registrationNumber: string;
    lat: number;
    lon: number;
    heading: number;
  } | null>(null);
  const [isPlaneModalVisible, setIsPlaneModalVisible] = useState(false);
  
  // Используем ref для отслеживания предыдущих значений и предотвращения лишних вызовов
  const prevParamsRef = useRef<{
    planeIds: number[];
    dateFrom: Date | null;
    dateTo: Date | null;
  } | null>(null);
  const isInitialMountRef = useRef(true);

  // Calculate bearing (heading) from origin to destination in degrees (0-360)
  const calculateBearing = useCallback((lat1: number, lon1: number, lat2: number, lon2: number): number => {
    const toRad = (deg: number) => deg * (Math.PI / 180);
    const toDeg = (rad: number) => rad * (180 / Math.PI);
    
    const dLon = toRad(lon2 - lon1);
    const lat1Rad = toRad(lat1);
    const lat2Rad = toRad(lat2);
    
    const y = Math.sin(dLon) * Math.cos(lat2Rad);
    const x = Math.cos(lat1Rad) * Math.sin(lat2Rad) - Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLon);
    
    let bearing = toDeg(Math.atan2(y, x));
    
    // Normalize to 0-360 range
    bearing = (bearing + 360) % 360;
    
    return bearing;
  }, []);

  // Загружаем данные для карты через AircraftMap API
  const loadAircraftMap = useCallback(async () => {
    try {
      const request = new ScheduleApiAircraftMapRequest();
      request.setIspublic(true); // Для публичной страницы показываем только публичные расписания
      
      const response = await ScheduleApi.getAircraftMap(request);
      
      if (response.getResultresponse()?.getIssuccessful()) {
        const aircraftLocations = response.getAircraftlocationsList();
        const flights: typeof flightsForMap = [];
        
        aircraftLocations.forEach((location: any) => {
          const plane = location.getPlane();
          if (!plane) return;
          
          let lat = 0;
          let lon = 0;
          let heading = 0;
          
          if (location.getIsinflight()) {
            // Самолет в полете
            const airportFrom = location.getAirportfrom();
            const airportTo = location.getAirportto();
            
            if (airportTo) {
              lat = parseFloat(airportTo.getLatitude() || '0');
              lon = parseFloat(airportTo.getLongitude() || '0');
              
              // Вычисляем heading от точки отправления к точке назначения
              if (airportFrom) {
                const fromLat = parseFloat(airportFrom.getLatitude() || '0');
                const fromLon = parseFloat(airportFrom.getLongitude() || '0');
                if (!isNaN(fromLat) && !isNaN(fromLon) && !isNaN(lat) && !isNaN(lon)) {
                  heading = calculateBearing(fromLat, fromLon, lat, lon);
                }
              }
            }
          } else {
            // Самолет на стоянке
            const currentAirport = location.getCurrentairport();
            if (currentAirport) {
              lat = parseFloat(currentAirport.getLatitude() || '0');
              lon = parseFloat(currentAirport.getLongitude() || '0');
              heading = 0; // На стоянке heading не важен
            }
          }
          
          // Добавляем только если есть валидные координаты
          if (!isNaN(lat) && !isNaN(lon) && lat !== 0 && lon !== 0) {
            flights.push({
              planeId: plane.getPlaneid(),
              registrationNumber: plane.getRegistrationnumber() || '',
              lat: lat,
              lon: lon,
              heading: heading,
            });
          }
        });
        
        setFlightsForMap(flights);
      }
    } catch (error) {
      console.error('Error loading aircraft map:', error);
      setFlightsForMap([]);
    }
  }, [calculateBearing]);

  // Component to fit map bounds to all aircraft - only runs once on initial load
  const FitBounds = ({ flights }: { flights: typeof flightsForMap }) => {
    const map = useMap();
    const hasFittedBoundsRef = useRef<boolean>(false);
    const processedFlightsKeyRef = useRef<string | null>(null);

    useEffect(() => {
      // Create a stable key from flights
      const flightsKey = flights.length > 0 
        ? flights.map(f => `${f.planeId}-${f.lat.toFixed(4)}-${f.lon.toFixed(4)}`).sort().join('|')
        : 'empty';

      // If we've already processed these exact flights, don't do anything
      if (processedFlightsKeyRef.current === flightsKey) {
        return;
      }

      // If flights haven't loaded yet, set default view once
      if (flights.length === 0) {
        if (processedFlightsKeyRef.current === null) {
          map.setView([20.5937, 78.9629], 4);
          processedFlightsKeyRef.current = 'empty';
        }
        return;
      }

      // Mark these flights as processed immediately to prevent re-processing
      processedFlightsKeyRef.current = flightsKey;
      hasFittedBoundsRef.current = true;

      // Calculate bounds from all aircraft positions
      const lats = flights.map(f => f.lat);
      const lons = flights.map(f => f.lon);
      
      const minLat = Math.min(...lats);
      const maxLat = Math.max(...lats);
      const minLon = Math.min(...lons);
      const maxLon = Math.max(...lons);

      // Add padding (10% on each side)
      const latPadding = (maxLat - minLat) * 0.1 || 1; // Fallback if all same lat
      const lonPadding = (maxLon - minLon) * 0.1 || 1; // Fallback if all same lon

      const bounds = L.latLngBounds(
        [minLat - latPadding, minLon - lonPadding],
        [maxLat + latPadding, maxLon + lonPadding]
      );

      // Fit bounds only once when flights are first available
      map.fitBounds(bounds, {
        padding: [80, 80], // Additional padding in pixels
        maxZoom: 18,
        animate: false, // Disable animation for initial load
      });

      // Ensure minimum zoom level (4 = country-level view)
      setTimeout(() => {
        const currentZoom = map.getZoom();
        if (currentZoom && currentZoom < 4) {
          map.setZoom(4);
        }
      }, 100);
    }, [flights, map]);

    return null;
  };

  const createPlaneIcon = (heading: number) =>
    L.divIcon({
      className: "map-plane-icon",
      html: `<div style="display:flex;align-items:center;justify-content:center;width:32px;height:32px;transform:rotate(${heading}deg);color:#000;font-size:28px;">✈</div>`,
      iconSize: [32, 32],
      iconAnchor: [16, 16],
    });

  // Load planes using fetchOwnPlanes to get only user's approved planes
  useEffect(() => {
    let isMounted = true;

    const loadPlanes = async () => {
      try {
        const options = await fetchOwnPlanes("");
        const planes = options.map((option) => ({
          id: option.value as number,
          registrationNumber: option.label,
        }));

        if (isMounted) {
          setAllPlanes(planes);
          // If we have a defaultSelectedPlane from URL and it's not in the list yet, add it
          if (defaultSelectedPlane && !planes.find(p => p.id === defaultSelectedPlane.id)) {
            setAllPlanes([...planes, defaultSelectedPlane]);
          }
        }
      } catch (error) {
        console.error('Failed to load plane list', error);
      }
    };

    loadPlanes();

    return () => {
      isMounted = false;
    };
  }, [defaultSelectedPlane]);

  // Вычисляем диапазон дат для запроса
  const dateRangeForRequest = useMemo(() => {
    if (!visibleDateRange) {
      // Если видимый диапазон еще не установлен, используем текущую дату для вычисления недели
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 1); // Понедельник
      startOfWeek.setHours(0, 0, 0, 0);
      
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // Воскресенье
      endOfWeek.setHours(23, 59, 59, 999);
      
      return { dateFrom: startOfWeek, dateTo: endOfWeek };
    } else {
      return { dateFrom: visibleDateRange.start, dateTo: visibleDateRange.end };
    }
  }, [visibleDateRange, currentDate]);

  // Загружаем данные при изменении выбранных самолетов или видимого диапазона дат
  useEffect(() => {
    // Проверяем, изменились ли параметры запроса
    const planeIdsStr = selectedPlaneIds.sort().join(',');
    const prevPlaneIdsStr = prevParamsRef.current?.planeIds.sort().join(',') || '';
    const dateFromStr = dateRangeForRequest.dateFrom.toISOString();
    const dateToStr = dateRangeForRequest.dateTo.toISOString();
    const prevDateFromStr = prevParamsRef.current?.dateFrom?.toISOString() || '';
    const prevDateToStr = prevParamsRef.current?.dateTo?.toISOString() || '';
    
    // Пропускаем вызов, если параметры не изменились (кроме первого рендера)
    if (!isInitialMountRef.current && 
        planeIdsStr === prevPlaneIdsStr && 
        dateFromStr === prevDateFromStr && 
        dateToStr === prevDateToStr) {
      return;
    }

    // Обновляем ref с текущими параметрами
    prevParamsRef.current = {
      planeIds: [...selectedPlaneIds],
      dateFrom: new Date(dateRangeForRequest.dateFrom),
      dateTo: new Date(dateRangeForRequest.dateTo),
    };

    dispatch(getSchedule({
      page: InitialPage,
      dateFrom: dateRangeForRequest.dateFrom,
      dateTo: dateRangeForRequest.dateTo,
      planeIds: selectedPlaneIds,
      isPublic: true, // Всегда показываем только публичные события
    }));

    isInitialMountRef.current = false;

    return () => {
      dispatch(clearScheduleResult())
    }
  }, [selectedPlaneIds, dateRangeForRequest, dispatch])

  // Обработчики для FullCalendar - без возможности редактирования
  const handleEventClick = (event: IPlaneEvent) => {
    // На публичной странице нельзя редактировать события
    // Можно оставить пустым или показать только информацию
  };

  const handleDateSelect = (start: Date, end: Date) => {
    // На публичной странице нельзя создавать события
  };

  const handleCalendarDateChange = (date: Date) => {
    setCurrentDate(date);
  };

  const handleDatesChange = useCallback((start: Date, end: Date) => {
    // Проверяем, изменились ли даты, чтобы избежать лишних обновлений
    const startStr = start.toISOString().split('T')[0];
    const endStr = end.toISOString().split('T')[0];
    
    if (!visibleDateRange || 
        visibleDateRange.start.toISOString().split('T')[0] !== startStr ||
        visibleDateRange.end.toISOString().split('T')[0] !== endStr) {
      setVisibleDateRange({ start, end });
    }
  }, [visibleDateRange]);

  // Загружаем данные для карты при открытии вкладки карты
  useEffect(() => {
    if (activeTabKey === TABS.map) {
      loadAircraftMap();
    }
  }, [activeTabKey, loadAircraftMap]);

  // Фильтруем события на клиенте по выбранным фильтрам
  const filteredEvents = useMemo(() => {
    return items.filter((event) => {
      // Фильтр по аэропортам (проверяем airportFrom и airportTo)
      if (filters.airportIds && filters.airportIds.length > 0) {
        const matchesAirport = 
          filters.airportIds.includes(event.airportFrom.id) ||
          (event.airportTo && filters.airportIds.includes(event.airportTo.id));
        if (!matchesAirport) {
          return false;
        }
      }

      return true;
    });
  }, [items, filters]);

  const selectedEventForModal = useMemo(() => {
    if (!selectedFlightForMap) {
      return null;
    }

    const planeEvents = filteredEvents.filter(
      (event) => event.plane.id === selectedFlightForMap.planeId,
    );

    if (planeEvents.length === 0) {
      return null;
    }

    const now = new Date();

    const activeEvent = planeEvents.find(
      (event) => event.dateFrom <= now && now <= event.dateTo,
    );

    if (activeEvent) {
      return activeEvent;
    }

    return planeEvents.reduce((closest, current) => {
      const closestDiff = Math.abs(
        closest.dateFrom.getTime() - now.getTime(),
      );
      const currentDiff = Math.abs(
        current.dateFrom.getTime() - now.getTime(),
      );

      return currentDiff < closestDiff ? current : closest;
    });
  }, [filteredEvents, selectedFlightForMap]);

  const formatDateOnly = (date: Date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const getTailNumberForModal = () => {
    if (!selectedEventForModal) {
      return selectedFlightForMap?.registrationNumber || 'N/A';
    }

    return selectedEventForModal.plane.registrationNumber || 'N/A';
  };

  const getPlaneModelForModal = () => {
    if (!selectedEventForModal) {
      return 'N/A';
    }

    const plane = selectedEventForModal.plane;

    if (plane.planeTypeName) {
      return plane.planeTypeName;
    }

    if (plane.planeType && plane.planeType.name) {
      return plane.planeType.name;
    }

    return 'N/A';
  };

  const formatAirportCode = (airport: any | undefined) => {
    if (!airport) {
      return 'N/A';
    }

    return airport.iataCode || airport.icaoCode || 'N/A';
  };

  const formatAirportLocationLine = (airport: any | undefined) => {
    if (!airport) {
      return 'N/A';
    }

    const parts: string[] = [];

    if (airport.cityName) {
      parts.push(airport.cityName);
    }

    if (airport.countryName) {
      parts.push(airport.countryName);
    }

    if (parts.length === 0) {
      return 'N/A';
    }

    return parts.join(', ');
  };


  const renderCalendarContent = () => (
    <>
      <FullCalendarWrapper
        events={filteredEvents}
        onEventClick={handleEventClick}
        onDateSelect={handleDateSelect}
        onDatesChange={handleDatesChange}
        height={isMobile ? 651 : 600}
        initialView="dayGridMonth"
        initialDate={currentDate}
        firstDayOfWeek={weekStartsSunday ? 0 : 1}
        headerRightContent={
          <WeekToggleWrapper>
            <Switch
              checked={weekStartsSunday}
              onChange={setWeekStartsSunday}
              size="small"
            />
            <span>
              {intl.formatMessage(SchedulePageMessages.weekStartsSunday)}
            </span>
          </WeekToggleWrapper>
        }
      />
    </>
  );

  const renderCalendarTimelineContent = () => (
      <>
        <TimelineContentWrapper isMobile={isMobile}>
          <PlaneRegistrationContainer isMobile={isMobile}>
            {allPlanes.length > 0 ? (
              allPlanes.map((plane) => (
                <PlaneRegistrationNumber key={plane.id} isMobile={isMobile}>
                  {plane.registrationNumber}
                </PlaneRegistrationNumber>
              ))
            ) : (
              <PlaneRegistrationPlaceholder isMobile={isMobile}>
                —
              </PlaneRegistrationPlaceholder>
            )}
          </PlaneRegistrationContainer>
          <TimelineCalendarContainer isMobile={isMobile}>
            <FullCalendarWrapper
              events={filteredEvents}
              onEventClick={handleEventClick}
              onDateSelect={handleDateSelect}
              onDatesChange={handleDatesChange}
              height={isMobile ? 651 : 600}
              initialView="timelineWeek"
              initialDate={currentDate}
              firstDayOfWeek={weekStartsSunday ? 0 : 1}
              availableViewModes={['week']}
              initialViewMode="week"
              planeList={allPlanes}
              headerRightContent={
                <WeekToggleWrapper>
                  <Switch
                    checked={weekStartsSunday}
                    onChange={setWeekStartsSunday}
                    size="small"
                  />
                  <span>
                    {intl.formatMessage(SchedulePageMessages.weekStartsSunday)}
                  </span>
                </WeekToggleWrapper>
              }
            />
          </TimelineCalendarContainer>
        </TimelineContentWrapper>
      </>
  );

  return (
    <PageWrapper>
      <CustomCard width={"max"} title={intl.formatMessage(SchedulePageMessages.title)} isContainerCard={true}>
        <TabsAndFiltersRow>
          <MobileFiltersWrapper>
            <StyledDebounceSelect
              mode={"multiple"}
              fetchOptions={fetchOwnPlanes}
              placeholder={intl.formatMessage(CommonFormMessages.planePlaceholder)}
              showSearch={true}
              allowClear={false}
              style={{width: 200}}
              defaultOptions={defaultSelectedPlane ? [getInitialOwnPlaneForSelect(defaultSelectedPlane)] : []}
              value={selectedPlaneIds.map(id => {
                const plane = allPlanes.find(p => p.id === id) || (defaultSelectedPlane && defaultSelectedPlane.id === id ? defaultSelectedPlane : null);
                return plane ? getInitialOwnPlaneForSelect(plane) : null;
              }).filter((item): item is DebounceSelectOptionProps => item !== null)}
              onChange={(values) => {
                const ids = Array.isArray(values) 
                  ? values.map(v => typeof v === 'object' ? v.value : v).filter((id): id is number => typeof id === 'number')
                  : [];
                setSelectedPlaneIds(ids);
              }}
            />
            <EventCalendarSimpleFilters 
              filters={filters} 
              onFiltersChange={setFilters}
              selectedPlaneIds={selectedPlaneIds}
              onPlaneIdsChange={setSelectedPlaneIds}
            />
          </MobileFiltersWrapper>
          <TabsWrapper>
            <CustomTabs 
              activeKey={activeTabKey} 
              onChange={(key) => setActiveTabKey(key as TabKey)} 
              destroyInactiveTabPane
              tabBarExtraContent={
                <DesktopFiltersWrapper>
                  <StyledDebounceSelect
                    mode={"multiple"}
                    fetchOptions={fetchOwnPlanes}
                    placeholder={intl.formatMessage(CommonFormMessages.planePlaceholder)}
                    showSearch={true}
                    allowClear={true}
                    style={{width: 200}}
                    defaultOptions={defaultSelectedPlane ? [getInitialOwnPlaneForSelect(defaultSelectedPlane)] : []}
                    value={selectedPlaneIds.map(id => {
                      const plane = allPlanes.find(p => p.id === id) || (defaultSelectedPlane && defaultSelectedPlane.id === id ? defaultSelectedPlane : null);
                      return plane ? getInitialOwnPlaneForSelect(plane) : null;
                    }).filter((item): item is DebounceSelectOptionProps => item !== null)}
                    onChange={(values) => {
                      const ids = Array.isArray(values) 
                        ? values.map(v => typeof v === 'object' ? v.value : v).filter((id): id is number => typeof id === 'number')
                        : [];
                      setSelectedPlaneIds(ids);
                    }}
                  />
                  <EventCalendarSimpleFilters 
              filters={filters} 
              onFiltersChange={setFilters}
              selectedPlaneIds={selectedPlaneIds}
              onPlaneIdsChange={setSelectedPlaneIds}
            />
                </DesktopFiltersWrapper>
              }
              items={[
                {
                  key: TABS.calendar,
                  label: (
                    <TabLabel>
                      <TabIconWrapper>
                        {activeTabKey === TABS.calendar ? <CalendarIcon /> : <CalendarBlackIcon />}
                      </TabIconWrapper>
                      {intl.formatMessage(SchedulePageMessages.calendarTab)}
                    </TabLabel>
                  ),
                  children: renderCalendarContent(),
                },
                {
                  key: TABS.timeline,
                  label: (
                    <TabLabel>
                      <TabIconWrapper>
                        {activeTabKey === TABS.timeline ? <TimelineIcon /> : <TimelineBlackIcon />}
                      </TabIconWrapper>
                      {intl.formatMessage(SchedulePageMessages.timelineTab)}
                    </TabLabel>
                  ),
                  children: renderCalendarTimelineContent(),
                },
                {
                  key: TABS.map,
                  label: (
                    <TabLabel>
                      <TabIconWrapper>
                        {activeTabKey === TABS.map ? <MapIcon /> : <MapBlackIcon />}
                      </TabIconWrapper>
                      {intl.formatMessage(SchedulePageMessages.mapTab)}
                    </TabLabel>
                  ),
                  children: (
                    <MapWrapper>
                      <MapContainer
                        center={[20.5937, 78.9629]}
                        zoom={4}
                        minZoom={3}
                        style={{ height: "100%", width: "100%" }}
                      >
                        <TileLayer
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <FitBounds flights={flightsForMap} />
                        {flightsForMap.map((flight) => (
                          <Marker
                            key={flight.planeId}
                            position={[flight.lat, flight.lon]}
                            icon={createPlaneIcon(flight.heading)}
                            eventHandlers={{
                              click: () => {
                                setSelectedFlightForMap(flight);
                                setIsPlaneModalVisible(true);
                              },
                            }}
                          />
                        ))}
                      </MapContainer>
                    </MapWrapper>
                  ),
                },
              ]}
            />
          </TabsWrapper>
        </TabsAndFiltersRow>
      </CustomCard>

      <PlaneTooltipCardModal
        open={isPlaneModalVisible}
        onCancel={() => {
          setIsPlaneModalVisible(false);
          setSelectedFlightForMap(null);
        }}
        footer={null}
        centered
        destroyOnClose
      >
        {selectedFlightForMap && (
          <PlaneTooltipCard>
            <TailNumberText>{getTailNumberForModal()}</TailNumberText>
            <PlaneModelText>{getPlaneModelForModal()}</PlaneModelText>
            <RouteGrid>
              <RouteSpacer>
                <RouteLine>
                  <PlaneIconSvg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L3 14V16L10.5 13.5V19L8 20.5V22L12 21L16 22V20.5L13.5 19V13.5L21 16Z" fill="#808080"/>
                  </PlaneIconSvg>
                  <RouteLineElement />
                  <RouteCircle />
                </RouteLine>
              </RouteSpacer>
              {selectedEventForModal ? (
                <>
                  <DateText style={{ gridColumn: 1, gridRow: 1 }}>
                    {formatDateOnly(selectedEventForModal.dateFrom)}
                  </DateText>
                  <DateText style={{ gridColumn: 3, gridRow: 1 }}>
                    {formatDateOnly(selectedEventForModal.dateTo)}
                  </DateText>
                  <AirportCodeText style={{ gridColumn: 1, gridRow: 2 }}>
                    {formatAirportCode(selectedEventForModal.airportFrom)}
                  </AirportCodeText>
                  <AirportCodeText style={{ gridColumn: 3, gridRow: 2 }}>
                    {selectedEventForModal.airportTo 
                      ? formatAirportCode(selectedEventForModal.airportTo)
                      : 'N/A'}
                  </AirportCodeText>
                  <AirportLocationText style={{ gridColumn: 1, gridRow: 3 }}>
                    {formatAirportLocationLine(selectedEventForModal.airportFrom)}
                  </AirportLocationText>
                  <AirportLocationText style={{ gridColumn: 3, gridRow: 3 }}>
                    {selectedEventForModal.airportTo 
                      ? formatAirportLocationLine(selectedEventForModal.airportTo)
                      : 'N/A'}
                  </AirportLocationText>
                </>
              ) : (
                <>
                  <DateText style={{ gridColumn: 1, gridRow: 1 }}>N/A</DateText>
                  <DateText style={{ gridColumn: 3, gridRow: 1 }}>N/A</DateText>
                  <AirportCodeText style={{ gridColumn: 1, gridRow: 2 }}>N/A</AirportCodeText>
                  <AirportCodeText style={{ gridColumn: 3, gridRow: 2 }}>N/A</AirportCodeText>
                  <AirportLocationText style={{ gridColumn: 1, gridRow: 3 }}>N/A</AirportLocationText>
                  <AirportLocationText style={{ gridColumn: 3, gridRow: 3 }}>N/A</AirportLocationText>
                </>
              )}
            </RouteGrid>
          </PlaneTooltipCard>
        )}
      </PlaneTooltipCardModal>
    </PageWrapper>
  );
};

